import React, { useState } from 'react';
import { Form } from 'antd';

import CustomButton from '../../components/button';
import CustomFlexLayout from '../../components/flexLayout';
import LinkComponent from '../../components/linkComponent';
import SingleSlideSwiper from '../../components/carrousel/singleSideSwiper';

import '../../assets/scss/index.scss';
import { carouselBibleSeminarImages } from '../../constants/dummydata';
import RegisterSeminarModal from '../../components/modal/registerSeminarModal/registerSeminarModal';
import PATHS from '../../routes/paths';
import { useNavigate } from 'react-router-dom';
import en from '../../constants/translations/en';

import { useGetActiveBibleSeminarIdQuery } from '../../redux/slices/bibleSeminarsApiSlice';

const BibleSeminars = () => {
  const { data, error, isLoading } = useGetActiveBibleSeminarIdQuery();
  const navigate = useNavigate();
  const [activeCollapseKey, setActiveCollapseKey] = useState(['1']);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isContentWhtYouLearn, setIsContentWhtYouLearn] = useState(false);
  const [isContentFAQ, setIsContentFAQ] = useState(false);
  const [form] = Form.useForm();
  const activeEvent = data?.data?.activeBibleSeminar || {};

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    form.submit(); // Handle form submission
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const toggleWhatYouLearnVisibility = () => {
    setIsContentWhtYouLearn(!isContentWhtYouLearn);
  }

  const toggleFAQVisibility = () => {
    setIsContentFAQ(!isContentFAQ);
  }

  const sectionMap = {
    1: 'heresWhatYouWillLearn-title',
    2: 'reasonsYouShouldAttendThisSeminar-title',
    3: 'faq-title',
    heresWhatYouWillLearn: 'heresWhatYouWillLearn-title',
    reasonsYouShouldAttendThisSeminar: 'reasonsYouShouldAttendThisSeminar-title',
    faq: 'faq-title'
  };

  const smoothScrollTo = (targetRef) => {
    if (!targetRef) return;

    const checkAndScroll = () => {
      const element = targetRef.current || document.getElementById(targetRef);
      if (!element) return;

      requestAnimationFrame(() => {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest'
        });
      });
    };

    setTimeout(checkAndScroll, 800);
  };

  const handleLinkClick = (type) => {
    if (type === 'contact') {
      navigate(PATHS.CONTACT_US);
    } else {
      const keyMap = {
        statementOfFaith: '2',
        commandmentsOfChrist: '3',
        doctrinesToBeRejected: '4'
      };
      const key = keyMap[type];
      setActiveCollapseKey([key]);
      setTimeout(() => {
        const sectionId = sectionMap[type];
        smoothScrollTo(sectionId);
      }, 800);
    }
  };

  const handleCollapseChange = (key) => {
    setActiveCollapseKey(key);

    if (key && key.length > 0) {
      const activeKey = key[0];
      const sectionId = sectionMap[activeKey];

      setTimeout(() => {
        smoothScrollTo(sectionId);
      }, 800);
    }
  };

  const getCarousel = () => {
    return (
      <div className='carousel-container radius-10'>
        <SingleSlideSwiper
          data={carouselBibleSeminarImages}
          clickable={true}
          navigation={false}
          className='mySwiper img-carousel-slide'
        />
      </div>
    );
  };

  const seminarItems = [
    {
      key: 1,
      id: 'heresWhatYouWillLearn',
      heading: en.bibleSeminars.heresWhatYouWillLearn.heading,
      title: en.bibleSeminars.heresWhatYouWillLearn.title,
      content: '',
      paragraphs: en.bibleSeminars.heresWhatYouWillLearn.introParagraphs
    },
    {
      key: 2,
      id: 'reasonsYouShouldAttendThisSeminar',
      heading: en.bibleSeminars.reasonsYouShouldAttendThisSeminar.heading,
      title: en.bibleSeminars.reasonsYouShouldAttendThisSeminar.title,
      content: '',
      paragraphs: en.bibleSeminars.reasonsYouShouldAttendThisSeminar.introParagraphs,
      isReasonsToJoin: true
    },
    {
      key: 3,
      id: 'faq',
      heading: en.bibleSeminars.faq.heading,
      title: en.bibleSeminars.faq.title,
      content: '',
      paragraphs: en.bibleSeminars.faq.introParagraphs,
      isFAQ: true
    }
  ];

  const bibleSeminarsItems = seminarItems.map((item) => ({
    key: item.key,
    label: (
      <p id={`${item.id}-title`} className='manrope-20-bold m-0'>
        {item.heading}
      </p>
    ),
    children: (
      <>
        <div className={`${item.isFAQ && 'manrope-16-regular mb-12 pl-8 mt-6 line-height-26'}`}>
          {item.isFAQ ? (
            <div className={`${isContentFAQ && 'collapse-content-expand'} collapse-content`}>
              {item.paragraphs.slice(0, isContentFAQ ? item.paragraphs.length : 4).map((faq, index) =>
              (
                <React.Fragment key={`${index}`}>
                  <p className='manrope-16-semibold text-black-4 mb-5'>
                    {faq.heading}
                  </p>
                  <p className='manrope-16-regular text-black-4 mt-0'>
                    {faq.text}
                  </p>
                </React.Fragment>
              )
              )}
            </div>
          ) : item.isReasonsToJoin ? (
            <ol className='manrope-16-regular mb-12 pl-25 mt-6 line-height-26 text-justify collapse-content'>
              {item.paragraphs.map((text, index) => (
                <li key={index}> {(text)}</li>
              ))}
            </ol>
          ) : (
            <ul className={`manrope-16-regular mb-12 pl-25 mt-6 line-height-26 text-justify collapse-content ${isContentWhtYouLearn && 'collapse-content-expand'}`}>
              {item.paragraphs.slice(0, isContentWhtYouLearn ? item.paragraphs.length : 15).map((text, index) => (
                <li key={index}> {(text)}</li>
              ))}
            </ul>
          )}
        </div>
        <div className={`flex items-center w-100 ${!item.isReasonsToJoin ? 'justify-between' : 'justify-end'}`}>
          {!item.isReasonsToJoin && (
            <LinkComponent
              title={item.isFAQ && isContentFAQ ? 'Read Less...' : !item.isFAQ && isContentWhtYouLearn ? 'Read Less...' : 'Read More...'}
              className='manrope-16-medium text-blue-link p-0 mr-20'
              onClick={item.isFAQ ? toggleFAQVisibility : toggleWhatYouLearnVisibility}
            />
          )}
          {(!!data) && (
            <CustomButton
              title='Register Now'
              onClick={showModal}
              className='w-auto radius-5 manrope-16-medium'
            />
          )}
        </div>
      </>
    )
  }))

  return (
    <div className='bookroad-seminars-pg bookroad-believe-pg mt-16 pb-30 pg-layout-container'>
      <div className='bg-white believe-pg-inner radius-10'>
        <CustomFlexLayout
          carouselLayout={true}
          carouselContent={getCarousel()}
          itemsList={bibleSeminarsItems}
          flexLeftCol='w-25'
          collapseClass='custom-collapse-layout'
          leftFlexlg='35%'
          rightFlexlg='65%'
          activeCollapseKey={activeCollapseKey}
          onCollapseChange={handleCollapseChange}
        >
          <p className='m-0 manrope-24-bold'>Learn to Read the Bible</p>
        </CustomFlexLayout>

        <RegisterSeminarModal
          isModalOpen={isModalOpen}
          onCloseModal={handleCancel}
          activeBibleSeminar={activeEvent}
        />
      </div>
    </div>
  );
};

export default BibleSeminars;
